import React from "react";
import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { timeLabel } from "@/lib/status";

export default function RefreshBar({ lastUpdated, onRefresh, loading, testid = "refresh-btn" }) {
  return (
    <div className="flex items-center gap-3">
      {lastUpdated && (
        <span className="hidden text-xs text-stone-500 sm:inline" data-testid="last-updated">
          Last updated {timeLabel(lastUpdated, true)}
        </span>
      )}
      <Button
        variant="outline"
        size="sm"
        onClick={onRefresh}
        disabled={loading}
        data-testid={testid}
        className="gap-2 rounded-xl border-stone-200 font-semibold"
      >
        <RefreshCw className={`h-4 w-4 ${loading ? "animate-spin" : ""}`} strokeWidth={2.4} />
        Refresh
      </Button>
    </div>
  );
}
